import {
  throwOnErrorResponse
} from "./chunk-NVQHPHNR.js";
import {
  withVersion
} from "./chunk-UEDPR2CR.js";

// lib/ensure/ensure.ts
import { logResults } from "@lune/common/logger";
import { buildRedirectUri } from "@lune/common/paths";
var REDIRECT_LOGIN_TIMEOUT_MS = 1 * 1e3;
var ensureAuthenticated = async (version, LoginPage, Root) => {
  return withVersion(version, LoginPage, Root).then(
    async (auth) => auth.whoami().then(logResults("ensureAuthenticated:whoami")).then(
      () => new Response(null, {
        status: 200
      })
    )
  ).then(logResults("ensureAuthenticated:whoami:2")).then(throwOnErrorResponse).then(() => {
    const result = {
      loggedIn: true
    };
    return result;
  }).catch(() => {
    setTimeout(() => {
      window.location.assign(buildRedirectUri(LoginPage));
    }, REDIRECT_LOGIN_TIMEOUT_MS);
    const result = {
      loggedIn: false
    };
    return result;
  });
};

export {
  ensureAuthenticated
};
